// extracted by mini-css-extract-plugin
export default {"section":"Tools_section__O+LQl","container":"Tools_container__g8Nn2","grid":"Tools_grid__ziPuW","chip":"Tools_chip__aLl8d","visible":"Tools_visible__Ja1Ss","dot":"Tools_dot__xwIEV"};